import BigCitiesIcon from './icon/BigCitiesIcon'

const bigCities = [
  {
    name: "Strasbourg",
    position: [48.5734798, 7.7483326],
    icon: BigCitiesIcon,
    state: "Grand Est",
    vent: "2",
    neige: "C1",
    seisme: "3",
  },
  {
    name: "Bordeaux",
    position: [44.8457407, -0.6159378],
    icon: BigCitiesIcon,
    state: "Nouvelle-Aquitaine",
    vent: "1",
    neige: "A1",
    seisme: "2",
  },
  {
    name: "Lyon",
    position: [45.756295, 4.8219779],
    icon: BigCitiesIcon,
    state: "Auvergne-Rhône-Alpes",
    vent: "2",
    neige: "A2",
    seisme: "2",
  },
  {
    name: "Dijon",
    position: [47.3218551, 5.039368],
    icon: BigCitiesIcon,
    state: "Bourgogne-Franche-Comté",
    vent: "1",
    neige: "A1",
    seisme: "1",
  },
  {
    name: "Toulouse",
    position: [43.6045845, 1.4417641],
    icon: BigCitiesIcon,
    state: "Occitanie",
    vent: "1",
    neige: "A2",
    seisme: "1",
  },
  {
    name: "Lille",
    position: [50.6317096, 3.0686861],
    icon: BigCitiesIcon,
    state: "Hauts-de-France",
    vent: "3",
    neige: "A1",
    seisme: "2",
  },
  {
    name: "Rouen",
    position: [49.4449232, 1.0561541],
    icon: BigCitiesIcon,
    state: "Normandie",
    vent: "2",
    neige: "A1",
    seisme: "1",
  },
  {
    name: "Rennes",
    position: [48.1117198, -1.6830272],
    icon: BigCitiesIcon,
    state: "Bretagne",
    vent: "2",
    neige: "A1",
    seisme: "2",
  },
  {
    name: "Orléans",
    position: [47.8990671, 1.9031459],
    icon: BigCitiesIcon,
    state: "Centre-Val de Loire",
    vent: "2",
    neige: "A1",
    seisme: "1",
  },
  {
    name: "Paris",
    position: [48.8588589, 2.3264165],
    icon: BigCitiesIcon,
    state: "Île-de-France",
    vent: "2",
    neige: "A1",
    seisme: "1",
  },
  {
    name: "Nantes",
    position: [47.2179379, -1.5567006],
    icon: BigCitiesIcon,
    state: "Pays de la Loire",
    vent: "3",
    neige: "A1",
    seisme: "3",
  },
  {
    name: "Marseille",
    position: [43.2969942, 5.3620563],
    icon: BigCitiesIcon,
    state: "Provence-Alpes-Côte d’Azur",
    vent: "2",
    neige: "A2",
    seisme: "3",
  },
  {
    name: "Ajaccio",
    position: [41.9193354, 8.7368399],
    icon: BigCitiesIcon,
    state: "Corse",
    vent: "3",
    neige: "A2",
    seisme: "1",
  },
  {
    name: "Pointe-à-Pitre",
    position: [16.2410492, -61.5355473],
    icon: BigCitiesIcon,
    state: "Guadeloupe",
    vent: "5",
    neige: "0",
    seisme: "5",
  },
  {
    name: "Saint-Denis",
    position: [-20.8964595, 55.4350018],
    icon: BigCitiesIcon,
    state: "Réunion",
    vent: "5",
    neige: "0",
    seisme: "2",
  },
  {
    name: "Mamoudzou",
    position: [-12.7805816, 45.2302623],
    icon: BigCitiesIcon,
    state: "Mayotte",
    vent: "5",
    neige: "0",
    seisme: "3",
  },
  {
    name: "Cayenne",
    position: [4.9381385, -52.3372119],
    icon: BigCitiesIcon,
    state: "Guyane",
    vent: "1",
    neige: "0",
    seisme: "1",
  },
  {
    name: "Fort-de-France",
    position: [14.6078336, -61.0758571],
    icon: BigCitiesIcon,
    state: "Martinique",
    vent: "5",
    neige: "0",
    seisme: "5",
  },
  {
    name: "Saint-Pierre",
    position: [46.7818297, -56.1764619],
    icon: BigCitiesIcon,
    state: "Saint-Pierre-et-Miquelon",
    vent: "1",
    neige: "0",
    seisme: "1",
  },
  {
    name: "Papeete",
    position: [-17.5373218, -149.5659196],
    icon: BigCitiesIcon,
    state: "Polynésie française",
    vent: "-",
    neige: "-",
    seisme: "-",
  },
  {
    name: "Nouméa",
    position: [-22.2703661, 166.4369939],
    icon: BigCitiesIcon,
    state: " Nouvelle-Calédonie",
    vent: "-",
    neige: "-",
    seisme: "-",
  },
];

export default bigCities